import { d } from "./index-21b082e6.js";
import "./en-4402d6fc.js";
var s = {
  name: "kn",
  weekdays: "ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ".split("_"),
  months: "ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್".split("_"),
  weekdaysShort: "ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ".split("_"),
  monthsShort: "ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ".split("_"),
  weekdaysMin: "ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ".split("_"),
  ordinal: function(_) {
    return _;
  },
  formats: {
    LT: "A h:mm",
    LTS: "A h:mm:ss",
    L: "DD/MM/YYYY",
    LL: "D MMMM YYYY",
    LLL: "D MMMM YYYY, A h:mm",
    LLLL: "dddd, D MMMM YYYY, A h:mm"
  },
  relativeTime: {
    future: "%s ನಂತರ",
    past: "%s ಹಿಂದೆ",
    s: "ಕೆಲವು ಕ್ಷಣಗಳು",
    m: "ಒಂದು ನಿಮಿಷ",
    mm: "%d ನಿಮಿಷ",
    h: "ಒಂದು ಗಂಟೆ",
    hh: "%d ಗಂಟೆ",
    d: "ಒಂದು ದಿನ",
    dd: "%d ದಿನ",
    M: "ಒಂದು ತಿಂಗಳು",
    MM: "%d ತಿಂಗಳು",
    y: "ಒಂದು ವರ್ಷ",
    yy: "%d ವರ್ಷ"
  }
};
d.locale(s, null, !0);
export {
  s as default
};
